export default __webpack_public_path__ + "static/media/line1.76cc66f5.svg";